import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  margin-top: 20px;

  .avatar {
    display: flex;
    justify-content: center;
    margin-right: 15px;
  }

  .schedule {
    flex: 1;
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .scheduleProfessional {
    margin-top: 10px;
  }
`

export const EmptyReservationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 25px;
  text-align: center;

  svg {
    margin-bottom: 10px;
  }

  & > p:nth-child(3) {
  line-height: 14px;
  text-align: center;
  width: 224px;
  margin-top: 10px;
  color: #898989;
}
`

export const InfoDialogContainer = styled.div`
  .icon {
    margin-top: 20px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dialogTitle {
    margin-bottom: 10px;
  }

  .content {
    margin-bottom: 20px
  }

  .paper {
    margin: 10px 0 20px 0;
    align-self: center;
    max-width: 100%;
  }
`

const variantStyles = (variant = 'success') =>
  ({
    success: css`
      > p {
        color: #4AC326;
      }
    `,
    error: css`
      > p {
        color: #898989;
        text-decoration: line-through;
      }
    `
  }[variant])

export const ScheduleTimeContainer = styled.div<{variant: 'success' | 'error'}>`
  ${({ variant }) => variantStyles(variant)}
`

export const ScheduleProfessionalInfoContainer = styled.div<{variant: 'success' | 'error'}>`
  > p {
    color: ${({ variant }) => variant === 'success' ? '#4B4B4B' : '#898989'};
    text-decoration: ${({ variant }) => variant === 'success' ? 'none' : 'line-through'};
  }
`